import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled, { css } from 'styled-components'
import InlineNotification from '@cx/couturier/InlineNotification'
import { TitleText, SubText, MaxWidthTextField } from 'cxid-common-components/util-components'
import { updateUsername, validateUsername, postUsername } from '../store/actions'
import config from '../utils/config'

const ErrorNotification = styled(InlineNotification)`
  margin-bottom: 40px;
  margin-top: -32px;

  ${({ theme: { media } }) =>
    media.smallMedium(
      css`
        margin-bottom: 32px;
        margin-top: -16px;
      `
    )}
`

const getParameterByName = (name, url) => {
  const cleanName = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${cleanName}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)
  if (!results) {
    return null
  }
  if (!results[2]) {
    return ''
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

const ErrorText = ({ validationError, lockedOut, missingData, serviceError, telephone }) => {
  if (validationError) {
    return <p>We were unable to match the information you provided to our records. Please review and try again.</p>
  }
  if (lockedOut) {
    return <p>Your account has been locked.</p>
  }
  if (missingData) {
    return (
      <p>
        Your account is missing information. Call customer service <a href={`tel:${telephone.replace(/[^0-9]/g, '')}`}>{telephone}</a> for assistance.
      </p>
    )
  }
  if (serviceError) {
    return (
      <p>
        Password recovery is unavailable right now. We’re sorry for the inconvenience. We’re hard at work trying to get back up and running so please
        try again later.
      </p>
    )
  }

  return ''
}

class Username extends PureComponent {
  componentDidMount() {
    const url = window.location.href
    const value = getParameterByName('username', url)
    const { dispatchUpdateUsername } = this.props
    if (value) {
      dispatchUpdateUsername({ target: { value } })
    }
    // REMOVES REDIRECT QUERY PARAM
    const newUrl = url.split('?')[0]
    window.history.pushState('', '', newUrl)

    const { username } = this.props
    if (username) {
      this.username.setSelectionRange(username.length, username.length)
    }
  }

  render() {
    const {
      username,
      usernameError,
      validationError,
      dispatchUpdateUsername,
      dispatchValidateUsername,
      missingData,
      lockedOut,
      supportHours,
      serviceError
    } = this.props

    const { item } = supportHours
    const { telephone } = item

    return (
      <div key="username" className="username">
        <TitleText hasSubtitle>We&#39;ll get you logged in again in no time.</TitleText>
        <SubText>To start we just need your username.</SubText>
        <div>
          {validationError || lockedOut || missingData || serviceError ? (
            <ErrorNotification canClose={false} className="inline-notify" isOpen type="error">
              <ErrorText
                lockedOut={lockedOut}
                missingData={missingData}
                serviceError={serviceError}
                telephone={telephone}
                validationError={validationError}
              />
            </ErrorNotification>
          ) : (
            ''
          )}
        </div>
        <MaxWidthTextField
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          autoFocus
          error={usernameError.length > 0}
          fullWidth
          id="username"
          inputRef={input => {
            this.username = input
          }}
          label="Username"
          message={usernameError || usernameError.length > 0 ? usernameError : ['Forgot your ', <a href={config.client.username}> username</a>, '?']}
          onBlur={dispatchValidateUsername}
          onChange={dispatchUpdateUsername}
          value={username}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchUpdateUsername: updateUsername,
      dispatchValidateUsername: validateUsername,
      dispatchPostUsername: postUsername
    },
    dispatch
  )

const mapStateToProps = state => ({
  username: state.form.username,
  usernameValid: state.form.usernameValid,
  usernameError: state.form.usernameError,
  supportHours: state.meta.supportHours,
  validationError: state.form.validationError,
  missingData: state.submit.missingData,
  serviceError: state.submit.serviceError,
  lockedOut: state.submit.lockedOut
})

export default connect(mapStateToProps, mapDispatchToProps)(Username)
